import { useForm } from "react-hook-form";
import { Button, Card, Form, Input, message, Space } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { LayoutData } from "../Structur/Aconlayout";
import React, { useState, useEffect, useRef } from "react";
import { Modal, Watermark } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

export const PasswortChange = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [username] = useState(queryParams.get("username"));
  const [code] = useState(queryParams.get("code"));

  const { getApiBaseUrl, user } = LayoutData();
  useEffect(() => {
    console.log("code, username", code, username);
    if (code === null || username === null); //navigate("/");
  }, [code, username]);

  console.log(queryParams, username);
  //http://localhost:3000/Profi/passwordchange?username=Christian&Code=007

  const onFinish = (values) => {
    const resetPassword = async (data, baseUrl) => {
      const response = await fetch(`${baseUrl}resetPassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          //Authorization: `Bearer ${bearer}`,
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) {
        message.info("Ihr Passwort ist nicht stark genug!");
        navigate(`/passwordchange?username=${username}&code=${code}`);
        //throw new Error("Network response was not ok", response.Error);
      } else {
        // return response.json();
        message.info("Ihr Passwort wurde geändert");
        navigate(`/login?username=${username}`);
      }
    };
    resetPassword(
      { email: username, resetCode: code, newPassword: values.password },
      getApiBaseUrl()
    );
    navigate("/");
  };

  return (
    <>
      <Watermark content="Neues Passwort vergeben" style={{ height: "100%" }}>
        <Modal
          title={<>Sie möchten Ihr Passwort neu festlegen!</>}
          width={400}
          centered
          open={true}
          cancelText="Schließen"
          onCancel={() => {
            navigate("/");
          }}
          //onOk={() => (false)}
          okText="-"
          okButtonProps={{ style: { display: "none" } }} // Hier wird der OK-Button ausgeblendet
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <Card
            title="Geben Sie Ihr neues Passwort 2x ein"
            style={{
              maxWidth: 400,
              marginTop: 25,
            }}
          >
            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item label="Username / EMail:" name="username">
                <Input
                  readOnly={true}
                  placeholder="Benutzername als EMail"
                  defaultValue={username}
                  prefix={<UserOutlined />}
                ></Input>
              </Form.Item>
              <Form.Item
                label="Passwort:"
                name="password"
                //        rules={passWortRoule}
              >
                <Input
                  type="password"
                  placeholder="Passwort"
                  required
                  prefix={<LockOutlined />}
                  allowClear={false}
                  disabled={false}
                ></Input>
              </Form.Item>
              <Form.Item
                label="Passwort bestätigen:"
                name="password2"
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "Bitte bestätigen Sie das Passwort!",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Die Passwörter stimmen nicht überein!")
                      );
                    },
                  }),
                ]}
              >
                <Input
                  type="password"
                  placeholder="Passwort bestätigen"
                  prefix={<LockOutlined />}
                  required
                  allowClear={false}
                  disabled={false}
                ></Input>
              </Form.Item>

              <Form.Item>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  //ref={defaultButtonRef}
                >
                  Neues Passwort speichern
                </Button>
              </Form.Item>
            </Form>
          </Card>
        </Modal>
      </Watermark>
    </>
  );
};

/*

<a href='http://localhost:3000/Profi/passwordchange?username=christian.pohanka@gmail.com&code=Q2ZESjhNZGVxc1ZJWjk5R3FMQVlILzdmMlVJbEdJREl0aFZmL3JPRFRYYmJDTEh4VDBHRHE2ZlpZeXA4Tm8yYUYzaEpRTVdEaFpzWUw3TTdTeXB0ZTVqSDBBQk50MVBkZU1GeG4xeTVnci9IVW1BWjl6UjZsUHRzMnhEcGozVjlOUktmaXFUM2p4K0xIcjFhb3BPdHZSYnZWaVZDNmJOTmJHcGltdUZFcEZhaFVQOVZLOGhsYWl0eVMyR0J4dmlzQjJWMmxOUHNPTS9ab3NmTCt0aEFDM2ZDOTRhaHYzK0dNL0g2Q2hUM2NwQm9xcndF'>Hier ist der Zauberlink</a>
*/